import {css} from 'lit'; export default css`:host{display:flex;flex-direction:row;--goto-icon-color:var(--goto-icon-color-secondary)}.action-button{margin-left:var(--goto-spacing-02)}`;
    